import { defineStore } from 'pinia'
import { cdnApi } from '@/helpers/api'

export const classList = ['warrior', 'magician', 'bowman', 'thief', 'pirate']

export interface ISkillCdn {
  title: string
  description: string
  image: string
}

interface ISkillStats {
  state: string
  value: string
}

export interface ICharacterCdn {
  attack: string
  basicSkills: ISkillCdn[]
  characterImage: string
  characterThumbnail: string
  characterVideo: string
  defense: string
  description: string
  difficulty: string
  fifthSkills: ISkillCdn[]
  id: number
  mobility: string
  name: string
  sixthSkills: ISkillCdn[]
  type: string
  class?: string
  sixthSkillVideo: string
  sixthTitle: string
  sixthDescription: string
  sixthLevel: string
  sixthStats: ISkillStats[]
  sixthCharacterBGImage: string
  special?: boolean
  specialText?: string
  specialImage?: string
  note?: string // stats note
}
export interface IClassJobCdn {
  Children: ICharacterCdn[]
  id: number
  name: string
}
interface ClassesJobsState {
  classesJobsList: IClassJobCdn[]
}

interface ISkills {
  displayName: string
  level: string
  fieldName: string
}

export const skillsList: ISkills[] = [
  { displayName: '1st-4th Job+Hyper Skills', level: '10', fieldName: 'basicSkills' },
  { displayName: '5th Job Skills', level: '200', fieldName: 'fifthSkills' },
  { displayName: '6th Job Skills', level: '260', fieldName: 'sixthSkills' },
]

const cjBaseAPI = '/classes-jobs'
export const useCJStore = defineStore('classesJobs', {
  state: (): ClassesJobsState => ({
    classesJobsList: [],
  }),
  actions: {
    async fetch() {
      if (this.classesJobsList.length > 0) return
      const { data }: { data: IClassJobCdn[] } = await cdnApi.get(cjBaseAPI)
      data.map((item: IClassJobCdn) =>
        item.Children.map((character: ICharacterCdn) => {
          character.class = item.name
          return character
        })
      )
      this.classesJobsList = data
    },
  },
})
